import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getInwardPackingReport = (start_date, end_date, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bundle-inward/packing-report/', {
        headers: authHeader(), params: {
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getWorkorderReport = (start_date, end_date, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/workorder-report/', {
        headers: authHeader(), params: {
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getInwardPackingDateWiseReport = (from_date, to_date, page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bundle-inward/packing-date-wise/', {
        headers: authHeader(),
        params: {
            ...(from_date && { from_date }),
            ...(to_date && { to_date }),
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            groupId: groupId,
            ordering: ordering,
        }
    });
};

const getOutwardPackingDateWiseReport = (from_date, to_date, page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bundle-outward/dispatch-report/', {
        headers: authHeader(),
        params: {
            ...(from_date && { from_date }),
            ...(to_date && { to_date }),
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            groupId: groupId,
            ordering: ordering,
        }
    });
};


const reportService = {
    getInwardPackingReport,
    getWorkorderReport,
    getInwardPackingDateWiseReport,
    getOutwardPackingDateWiseReport
};

export default reportService;
